import styled from 'styled-components'

export const Subtitle = styled.div`
  color: var(--shape);
  font-size: 2rem;
  font-weight: 400;
`
